import { Exclamation } from '../../../icons/SvgIcons';

type ErrorMessageProps = {
  message: string;
};

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="relative items-center">
      <div className="absolute mt-0.5">{Exclamation()}</div>
      <p className="ml-6 text-base font-normal text-red-900 text-left">
        {message}
      </p>
    </div>
  );
}
